export type DeviceNotification =
	| 'smokeAlarm'
	| 'floodAlarm'
	| 'mildGasAlarm'
	| 'heavyGasAlarm'
	| 'gasTestAlarm'
	| 'lowBattery'
	| 'device_problem'
	| 'forgotten_lights'
	| 'overpower'
	| 'overtemperature'
	| 'overvoltage'
	| 'offline'
	| 'ai_device_failure';

export interface deviceNotifPermissions {
	[key: string]: number[];
}

export enum NotifType {
	MAIL = 0,
	PUSH = 1,
}

export const testNotifications: string[] = [
	'overpower',
	'overtemperature',
	'overvoltage',
	'offline',
	'lowBattery',
	'smokeAlarm',
	'floodAlarm',
	'mildGasAlarm',
	'heavyGasAlarm',
	'gasTestAlarm',
	'ai_device_failure',
];
